import { AccountProvider } from '@/features/auth/shared/types/account-providers';

export const getProviderDisplayName = (provider: AccountProvider): string => {
  switch (provider) {
    case AccountProvider.FACEBOOK:
      return 'Facebook';
    case AccountProvider.GOOGLE:
      return 'Google';
    default:
      return provider;
  }
};
